"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Calendar.ISO", "date_to_string", 3, "public", [{params: (context) => [Type.variablePattern("x0_0"), Type.variablePattern("x1_1"), Type.variablePattern("x2_2")], guards: [], body: (context) => {
return Elixir_Calendar_ISO["date_to_string/4"](context.vars.x0_0, context.vars.x1_1, context.vars.x2_2, Type.atom("extended"));
}}]);

Interpreter.defineElixirFunction("Calendar.ISO", "date_to_string", 4, "public", [{params: (context) => [Type.variablePattern("year_0"), Type.variablePattern("month_1"), Type.variablePattern("day_2"), Type.variablePattern("format_3")], guards: [], body: (context) => {
return Erlang["iolist_to_binary/1"](Elixir_Calendar_ISO["date_to_iodata/4"](context.vars.year_0, context.vars.month_1, context.vars.day_2, context.vars.format_3));
}}]);

Interpreter.defineElixirFunction("Date", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Date")], [Type.atom("calendar"), Type.atom("Elixir.Calendar.ISO")], [Type.atom("day"), Type.atom("nil")], [Type.atom("month"), Type.atom("nil")], [Type.atom("year"), Type.atom("nil")]]);
}}]);

Interpreter.defineElixirFunction("Date", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
Interpreter.matchOperator(Elixir_Enum["reduce/3"](context.vars.kv_0, Type.tuple([Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Date")], [Type.atom("calendar"), Type.atom("Elixir.Calendar.ISO")], [Type.atom("day"), Type.atom("nil")], [Type.atom("month"), Type.atom("nil")], [Type.atom("year"), Type.atom("nil")]]), Type.list([Type.atom("year"), Type.atom("month"), Type.atom("day")])]), Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.tuple([Type.variablePattern("map_3"), Type.variablePattern("keys_4")])], guards: [], body: (context) => {
return Type.tuple([Elixir_Map["merge/2"](context.vars.map_3, Type.map([[context.vars.key_1, context.vars.val_2]])), Elixir_List["delete/2"](context.vars.keys_4, context.vars.key_1)]);
}}], context, "-__struct__/1-fun-0-")), Type.tuple([Type.variablePattern("map_5"), Type.variablePattern("keys_6")]), context);
Interpreter.updateVarsToMatchedValues(context);
return Interpreter.case(context.vars.keys_6, [{match: Type.list([]), guards: [], body: (context) => {
return context.vars.map_5;
}}, {match: Type.matchPlaceholder(), guards: [], body: (context) => {
return Erlang["error/1"](Elixir_ArgumentError["exception/1"](Type.bitstring([Type.bitstringSegment(Type.string("the following keys must also be given when building "), {type: "binary"}), Type.bitstringSegment(Type.string("struct "), {type: "binary"}), Type.bitstringSegment(Elixir_Kernel["inspect/1"](Type.atom("Elixir.Date")), {type: "binary"}), Type.bitstringSegment(Type.string(": "), {type: "binary"}), Type.bitstringSegment(Elixir_Kernel["inspect/1"](context.vars.keys_6), {type: "binary"})])));
}}], context);
}}]);

Interpreter.defineElixirFunction("String.Chars.Date", "__impl__", 1, "public", [{params: (context) => [Type.atom("for")], guards: [], body: (context) => {
return Type.atom("Elixir.Date");
}}, {params: (context) => [Type.atom("protocol")], guards: [], body: (context) => {
return Type.atom("Elixir.String.Chars");
}}]);

Interpreter.defineElixirFunction("String.Chars.Date", "to_string", 1, "public", [{params: (context) => [Type.map([[Type.atom("calendar"), Type.variablePattern("calendar_0")], [Type.atom("day"), Type.variablePattern("day_3")], [Type.atom("month"), Type.variablePattern("month_2")], [Type.atom("year"), Type.variablePattern("year_1")]])], guards: [], body: (context) => {
return Interpreter.callNamedFunction(context.vars.calendar_0, Type.atom("date_to_string"), Type.list([context.vars.year_1, context.vars.month_2, context.vars.day_3]), context);
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));